import React, { useEffect, useState } from "react";
import { timeToSeconds } from "../../../../Utilitie"; // actually not used here anymore
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import NoDataFound from "../../../../Extra/NoDataFound";
import { BiSolidReport } from "react-icons/bi";

const duration = ["Agreed_Demand", "Availed", "Engg_Demand"];

const CountSectionWiseBlockChart = ({ data, dataForTable }) => {
  const [arrangedData, setArrangedData] = useState(null);
  const [directionCharts, setDirectionCharts] = useState({});
  const [fyCharts, setFyCharts] = useState({});
  const [selectedDurationType, setSelectedDurationType] = useState("Availed");
  const [dataSetType, setDataSetType] = useState("FY"); // "Direction" | "FY"

  const getFY = (dateString) => {
    if (!dateString || typeof dateString !== "string") return "Unknown";
    const date = new Date(dateString);
    if (isNaN(date)) return "Unknown";
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return month >= 4
      ? `${year}-${(year + 1).toString().slice(-2)}`
      : `${year - 1}-${year.toString().slice(-2)}`;
  };

  const transformAndSumDataWithExtras = (inputData) => {
    const fyMap = {};
    inputData.forEach((item) => {
      if (!item?.reportDate) return;
      const fy = getFY(item.reportDate);
      if (!fyMap[fy]) fyMap[fy] = [];
      fyMap[fy].push(item);
    });

    const result = [];
    Object.entries(fyMap).forEach(([fy, fyData]) => {
      const resultForFY = [];
      const groupedByType = {};

      // ─── Count per direction+section per Type ───
      const engineeringData = fyData.filter(
        (item) => item?.Department === "ENGINEERING",
      );

      fyData.forEach((item) => {
        const type =
          item.Type === "MACHINE" && item.Department === "ENGINEERING"
            ? "MACHINE"
            : "OTHER";
        const direction = item.Direction || "N/A";
        const section = item.Section || "N/A";
        const key = `${direction}__${section}`;

        const agreed = item.Agreed_Demand !== "00:00:00" ? 1 : 0;
        const availed = item.Availed !== "00:00:00" ? 1 : 0;
        const engg = item.Engg_Demand !== "00:00:00" ? 1 : 0;

        if (!groupedByType[type]) groupedByType[type] = {};
        if (!groupedByType[type][key]) {
          groupedByType[type][key] = {
            direction,
            section,
            Agreed_Demand: 0,
            Availed: 0,
            Engg_Demand: 0,
          };
        }

        groupedByType[type][key].Agreed_Demand += agreed;
        groupedByType[type][key].Availed += availed;
        groupedByType[type][key].Engg_Demand += engg;
      });

      Object.entries(groupedByType).forEach(([type, entries]) => {
        resultForFY.push({ type, data: Object.values(entries) });
      });

      // ─── Corridor / Non-Corridor / Total ───
      const corridorGroups = {};
      const nonCorridorGroups = {};
      const total = {};

      fyData.forEach((item) => {
        // if (!item || item.Department !== "ENGINEERING") return;

        const direction = item.Direction || "N/A";
        const section = item.Section || "N/A";
        const key = `${direction}__${section}`;

        const agreed = item.Agreed_Demand !== "00:00:00" ? 1 : 0;
        const availed = item.Availed !== "00:00:00" ? 1 : 0;
        const engg = item.Engg_Demand !== "00:00:00" ? 1 : 0;

        const corr = item.Corridore?.toLowerCase?.();
        const targetGroup =
          corr === "corridor"
            ? corridorGroups
            : corr === "non-corridor"
              ? nonCorridorGroups
              : null;

        if (targetGroup) {
          if (!targetGroup[key]) {
            targetGroup[key] = {
              direction,
              section,
              Agreed_Demand: 0,
              Availed: 0,
              Engg_Demand: 0,
            };
          }
          targetGroup[key].Agreed_Demand += agreed;
          targetGroup[key].Availed += availed;
          targetGroup[key].Engg_Demand += engg;
        }

        if (!total[key]) {
          total[key] = {
            direction,
            section,
            Agreed_Demand: 0,
            Availed: 0,
            Engg_Demand: 0,
          };
        }
        total[key].Agreed_Demand += agreed;
        total[key].Availed += availed;
        total[key].Engg_Demand += engg;
      });

      if (Object.keys(corridorGroups).length > 0) {
        resultForFY.push({
          type: "Corridor",
          data: Object.values(corridorGroups),
        });
      }
      if (Object.keys(nonCorridorGroups).length > 0) {
        resultForFY.push({
          type: "Non-Corridor",
          data: Object.values(nonCorridorGroups),
        });
      }
      if (Object.keys(total).length > 0) {
        resultForFY.push({ type: "Total", data: Object.values(total) });
      }

      result.push({ fy, data: resultForFY });
    });

    return result;
  };

  // ────────────────────────────────────────────────
  // Direction-wise (original) preparation
  // ────────────────────────────────────────────────
  const prepareDirectionSeries = (fyData, valueKey, chartType) => {
    const yearSet = new Set();
    const directionMap = {};

    fyData.forEach(({ fy, data }) => {
      const year = fy.split("-")[0];
      yearSet.add(year);

      data.forEach((group) => {
        if (group.type !== chartType) return;
        group.data.forEach((item) => {
          const direction = item.direction || "N/A";
          if (!directionMap[direction])
            directionMap[direction] = { product: direction };
          directionMap[direction][year] =
            (directionMap[direction][year] || 0) + (item[valueKey] || 0);
        });
      });
    });

    const sortedYears = [...yearSet].sort();
    return {
      dimensions: ["product", ...sortedYears],
      series: Object.values(directionMap),
    };
  };

  // ────────────────────────────────────────────────
  // Financial-year-wise preparation (NEW)
  // ────────────────────────────────────────────────
  const prepareFySeries = (fyData, valueKey, chartType) => {
    const fyTotals = {};

    fyData.forEach(({ fy, data }) => {
      if (!fyTotals[fy]) fyTotals[fy] = 0;

      data.forEach((group) => {
        if (group.type === chartType) {
          group.data.forEach((item) => {
            fyTotals[fy] += item[valueKey] || 0;
          });
        }
      });
    });

    const sortedFYs = Object.keys(fyTotals).sort();
    return {
      dimensions: ["product", ...sortedFYs],
      series: [
        {
          product: chartType, // or "Count" / selectedDurationType — customize label if needed
          ...Object.fromEntries(sortedFYs.map((fy) => [fy, fyTotals[fy]])),
        },
      ],
    };
  };

  useEffect(() => {
    if (!data?.length) {
      setArrangedData(null);
      return;
    }
    const transformed = transformAndSumDataWithExtras(data);
    setArrangedData(transformed);
  }, [data]);

  useEffect(() => {
    if (!arrangedData?.length) return;

    const types = [
      ...new Set(arrangedData.flatMap((o) => o.data.map((d) => d.type))),
    ];

    // Direction-wise charts
    const dirCharts = {};
    types.forEach((type) => {
      dirCharts[type] = prepareDirectionSeries(
        arrangedData,
        selectedDurationType,
        type,
      );
    });
    setDirectionCharts(dirCharts);

    // Financial-year-wise charts
    const fyChartsData = {};
    types.forEach((type) => {
      fyChartsData[type] = prepareFySeries(
        arrangedData,
        selectedDurationType,
        type,
      );
    });
    setFyCharts(fyChartsData);
  }, [arrangedData, selectedDurationType]);

  const activeCharts = dataSetType === "FY" ? fyCharts : directionCharts;

  return (
    <div
      className="row papaDiv mx-0 my-2 p-2 rounded-3"
      style={{
        background: "#f7faff",
        border: "1px solid #d7e2ef",
        boxShadow: "0 4px 16px rgba(6, 59, 135, 0.08)",
      }}
    >
      {/* Header */}
      <div
        className="d-flex flex-wrap justify-content-between align-items-center gap-3 p-3 rounded-3 text-white"
        style={{
          background:
            "linear-gradient(135deg, #870606 0%, #b12b2b 72%, #730808 100%)",
        }}
      >
        <div className="d-flex flex-column gap-1">
          <h5 className="mb-0 fw-semibold d-flex align-items-center gap-2">
            <BiSolidReport size={22} />
            Agreed and Given Block (Count)
          </h5>

          <small style={{ opacity: 0.85, overflowWrap: "anywhere" }}>
            <span className="fw-semibold">Sections:</span>{" "}
            {dataForTable?.section?.length
              ? dataForTable.section.join(", ")
              : "All Sections"}
          </small>
        </div>

        {/* Filters */}
        <div className="d-flex flex-wrap gap-2 align-items-center">
          <select
            className="form-select form-select-sm"
            value={dataSetType}
            onChange={(e) => setDataSetType(e.target.value)}
            style={{
              minWidth: "175px",
              width: "auto",
              backgroundColor: "#fff",
              color: "#063b87",
              border: "1px solid #d7e2ef",
              borderRadius: "8px",
              fontWeight: 600,
            }}
          >
            <option value="FY">Financial Year Wise</option>
            <option value="Direction">Direction Wise</option>
          </select>

          <select
            className="form-select form-select-sm"
            value={selectedDurationType}
            onChange={(e) => setSelectedDurationType(e.target.value)}
            style={{
              minWidth: "155px",
              width: "auto",
              backgroundColor: "#fff",
              color: "#063b87",
              border: "1px solid #d7e2ef",
              borderRadius: "8px",
              fontWeight: 600,
            }}
          >
            {duration.map((type) => (
              <option key={type} value={type}>
                {type.replace("_", " ")}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Count Charts */}
      <div className="row g-3 mx-0 mt-1">
        {data?.length > 0 ? (
          Object.entries(activeCharts).map(([head, chartData], idx) => (
            <div className="col col-md col-xl" key={head || idx}>
              <div
                className="h-100 p-3 rounded-3 bg-white"
                style={{
                  border: "1px solid #d7e2ef",
                  boxShadow: "0 2px 8px rgba(6, 59, 135, 0.05)",
                  minWidth: 0,
                }}
              >
                <div className="d-flex align-items-start gap-2 mb-2">
                  <span
                    className="rounded-pill flex-shrink-0 mt-1"
                    style={{
                      width: "4px",
                      height: "28px",
                      background: idx % 2 === 0 ? "#0a57bb" : "#087344",
                    }}
                  />

                  <div className="flex-grow-1">
                    <h6
                      className="mb-1 fw-bold"
                      style={{
                        color: "#063b87",
                        overflowWrap: "anywhere",
                      }}
                    >
                      {head}
                    </h6>

                    <small className="text-secondary">
                      {selectedDurationType.replace("_", " ")} Count
                    </small>
                  </div>
                </div>

                <hr className="my-2" style={{ borderColor: "#d7e2ef" }} />

                {chartData?.series?.length > 0 ? (
                  <GroupedBarChart
                    data={chartData}
                    from="Block_C"
                    rotateText={dataSetType === "FY" ? 0 : 15}
                    chartType="bar"
                  />
                ) : (
                  <div className="text-center py-4">
                    <div
                      className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-3"
                      style={{
                        color: "#64748b",
                        background: "#f1f6fc",
                        border: "1px dashed #d7e2ef",
                      }}
                    >
                      <BiSolidReport size={18} />
                      <span className="small">No count data available</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 py-3">
            <NoDataFound />
          </div>
        )}
      </div>
    </div>
  );
};

export default CountSectionWiseBlockChart;
